import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import PageHero from "../components/PageHero";
import FadeIn from "../components/FadeIn";
import ContactForm from "../components/ContactForm";
import { COMPANY } from "../mock";
import useSEO from "../hooks/useSEO";

const Contacts = () => {
  useSEO({
    title: "Contacts — Dubai Office",
    description: "Contact Prime Trade L.L.C — FZ. Office at Meydan Grandstand, Nad Al Sheba, Dubai, UAE. Phone +971 50 827 0425. Email info@primetrade-fz.com.",
  });
  return (
    <main>
      <PageHero title="Contacts" eyebrow="Get in touch" breadcrumbs={[{ label: "Contacts" }]} />

      <section className="pt-section">
        <div className="max-w-[1280px] mx-auto px-6 grid lg:grid-cols-12 gap-12">
          <FadeIn className="lg:col-span-5">
            <div className="pt-eyebrow">Our office</div>
            <h2 className="pt-h2">Let's connect</h2>
            <div className="pt-divider" />
            <p className="text-[15px] text-[#4a4a4a] leading-relaxed mb-8">
              We will get back to you within one business day. Our team operates from Dubai and is available across multiple time zones for our partners worldwide.
            </p>
            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 bg-[#fef2f3] text-[#e30613] flex items-center justify-center shrink-0 rounded-sm"><Phone size={18} /></span>
                <div>
                  <div className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium">Phone</div>
                  <a href={`tel:${COMPANY.phonePrimary.replace(/\s/g, "")}`} className="text-[#2c2c2c] font-medium hover:text-[#e30613] block">{COMPANY.phonePrimary}</a>
                  <a href={`tel:${COMPANY.phoneSecondary.replace(/\s/g, "")}`} className="text-[#4a4a4a] text-sm hover:text-[#e30613] block">{COMPANY.phoneSecondary}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 bg-[#fef2f3] text-[#e30613] flex items-center justify-center shrink-0 rounded-sm"><Mail size={18} /></span>
                <div>
                  <div className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium">E-mail</div>
                  <a href={`mailto:${COMPANY.email}`} className="text-[#2c2c2c] font-medium hover:text-[#e30613]">{COMPANY.email}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 bg-[#fef2f3] text-[#e30613] flex items-center justify-center shrink-0 rounded-sm"><MapPin size={18} /></span>
                <div>
                  <div className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium">Address</div>
                  <div className="text-[#2c2c2c] font-medium">{COMPANY.address}</div>
                  <div className="text-[#4a4a4a] text-sm">{COMPANY.poBox}</div>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 bg-[#fef2f3] text-[#e30613] flex items-center justify-center shrink-0 rounded-sm"><Clock size={18} /></span>
                <div>
                  <div className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium">Working hours</div>
                  <div className="text-[#2c2c2c] font-medium">{COMPANY.hours}</div>
                </div>
              </li>
            </ul>
          </FadeIn>

          <FadeIn className="lg:col-span-7" delay={120}>
            <div className="bg-[#3a3a3a] p-8 md:p-10 rounded-sm">
              <div className="text-[#ff5a64] text-[13px] font-medium mb-3">Send order</div>
              <h3 className="text-[28px] font-bold text-white mb-2">Tell us about your enquiry</h3>
              <p className="text-white/65 text-sm mb-6">We will call you back within 10 minutes during business hours.</p>
              <ContactForm variant="dark" />
            </div>
          </FadeIn>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1280px] mx-auto px-6">
          <FadeIn>
            <div className="w-full h-[400px] overflow-hidden border border-[#ececec] rounded-sm">
              <iframe
                title="Office location"
                src="https://www.google.com/maps?q=Meydan+Grandstand+Nad+Al+Sheba+Dubai&output=embed"
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
};

export default Contacts;
